import { CloseSmallIcon, DeleteIcon } from '@core'
import { Checkbox, makeStyles } from '@material-ui/core'
import React, { FC } from 'react'
import { CentricTypography as Typography } from '@core/component/CentricTypography'
import classNames from 'classnames'
import { stores } from '@stores'
import { getProductAttributeValue } from '@utils/get-product-attribute-value'

export interface IAttributeFilterValueRowProps {
  id: string
  name: string
  attributeId?: string
  handleCheckboxSelection?: any
  handleFilterExclusion: any
  isSelected?: boolean
  isExcluded: boolean
  canShowCheckbox: boolean
  isDisabled?: boolean
  filterCount?: number
  rowHeight?: number
}

const useStyles = makeStyles(theme => ({
  listItem: ({ rowHeight }: any) => ({
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    height: rowHeight ? `${rowHeight}px` : '40px',
    paddingLeft: '10px'
  }),
  countWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    width: '20%'
  },
  checkboxLabelWrapper: {
    alignItems: 'center',
    justifyContent: 'flex-start',
    width: '80%',
    padding: '12px 0',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden'
  },
  checkbox: {
    color: theme.palette.text.primary,
    padding: '0 6px 0 0'
  },
  deSelectedCheckbox: {
    color: theme.palette.text.disabled,
    padding: '0 6px 0 0'
  },
  listElement: {
    width: 'calc(100% - 10px)'
  },
  excludedLabel: {
    textDecoration: 'line-through'
  },
  selectedLabel: {
    fontWeight: 600
  },
  removeIcon: {
    cursor: 'pointer'
  },
  disabledIcon: {
    pointerEvents: 'none',
    opacity: 0.5
  },
  excludedRemoveIcon: {
    borderRadius: 15,
    background: '#EEEEEE'
  },
  label: {
    textTransform: 'capitalize'
  }
}))

export const CNFAttributeFilterValueRow: FC<IAttributeFilterValueRowProps> = ({
  id,
  name,
  attributeId,
  handleCheckboxSelection,
  handleFilterExclusion,
  isSelected,
  canShowCheckbox,
  isExcluded,
  isDisabled,
  filterCount,
  rowHeight
}) => {
  const classes = useStyles({ rowHeight })

  const {
    productConfiguration: { defaultValuesFromConfig, findSpecificAttribute }
  } = stores

  const attributeObj = findSpecificAttribute(attributeId)
  let nodeText = name
  if (attributeObj) {
    nodeText = getProductAttributeValue(
      { name: nodeText },
      attributeObj,
      true,
      defaultValuesFromConfig
    )
  }

  return (
    <div className={classes.listItem}>
      <div
        className={classes.checkboxLabelWrapper}
        onClick={e => (canShowCheckbox ? handleCheckboxSelection(e, !isSelected) : null)}
      >
        {canShowCheckbox && (
          <Checkbox
            checked={isSelected}
            className={isSelected ? classes.checkbox : classes.deSelectedCheckbox}
            value={id}
            size='small'
            color='default'
            disabled={!!isDisabled}
          />
        )}
        <Typography
          variant={isDisabled ? 'captionLightGrey' : 'captionDarkGrey'}
          className={
            isSelected || !canShowCheckbox
              ? classNames(classes.label, classes.selectedLabel)
              : isExcluded
              ? classNames(classes.label, classes.selectedLabel, classes.excludedLabel)
              : classes.label
          }
        >
          {(nodeText ?? '').toString().toLowerCase()}
        </Typography>
      </div>
      <div className={classes.countWrapper}>
        <Typography
          variant='captionLightGrey'
          className={isExcluded ? classes.excludedLabel : ''}
        >{`(${filterCount})`}</Typography>
        {canShowCheckbox ? (
          <CloseSmallIcon
            onClick={handleFilterExclusion}
            className={classNames(
              isDisabled ? classes.disabledIcon : classes.removeIcon,
              isExcluded && classes.excludedRemoveIcon
            )}
          />
        ) : (
          <DeleteIcon onClick={handleFilterExclusion} className={classes.removeIcon} />
        )}
      </div>
    </div>
  )
}
